import type { Resource } from '../../';
export const header_utilBar_viewAccount: Resource = {"default":"View My Account"};
